import { useState } from 'react';
import { Icon } from './../../../ui';

type TreeType = {[key: string]: {[key: string]: string} | string};

export default function HierarchicalTree(props: {
	path?: string[],
	structure: TreeType,
	isMulti?: boolean,
	inheritedSetter?: (values: string[]) => void,
	values?: string[]
}) {
	let [values, setValues] = useState(props.values || []);
	let [isOpen, toggleOpen] = useState(false);

	function isChecked(path: string[]) {
		return (props.values ?? values).indexOf(path.join('>>')) > -1;
	}

	function _setValues(values: string[]) {
		if (props.inheritedSetter) {
			props.inheritedSetter(values);
		} else {
			setValues(values);
		}
	}

	function toggleValue(path: string[]) {
		if (!props.isMulti) {
			_setValues(isChecked(path) ? [] : [path.join('>>')]);
			return;
		}

		if (isChecked(path)) {
			_setValues((props.values ?? values).filter(value => value !== path.join('>>')))
		} else {
			_setValues([...(props.values ?? values), path.join('>>')]);
		}
	}

	return (
		<ul className="hierarchical">
			{Object.entries(props.structure).map(node => {
				const parent = typeof node[1] === 'object';
				const path = [...(props.path ?? []), node[0]];
				const icon = isOpen ? 'chevron-down' : 'chevron-right';

				return (
					<li key={path.join(',')} className={isOpen ? 'open' : ''}>
						{parent ?
							<>
								<span onClick={() => toggleOpen(state => !state)}>
									<Icon name={icon} />
									<span>{node[0]}</span>
								</span>

								<HierarchicalTree
									path={path}
									structure={node[1] as TreeType}
									inheritedSetter={props.inheritedSetter ?? setValues}
									values={props.values ?? values}
									isMulti={props.isMulti}
								/>
							</>
							:
							<label>
								<input
									type="checkbox"
									checked={isChecked(path)}
									onChange={() => toggleValue(path)}
								/>

								<span>{node[0]}</span>
							</label>
						}
					</li>
				);
			})}
		</ul>
	);
}
